import { useLocation } from 'react-router-dom'
import { getLocaleFromPathname, htmlLangFor, LOCALE_META, type SiteLocale } from './locale'

export function useLocale(): SiteLocale {
  const { pathname } = useLocation()
  return getLocaleFromPathname(pathname)
}

export function useLocaleMeta() {
  const { pathname } = useLocation()
  const locale = getLocaleFromPathname(pathname)
  return { locale, pathname, ...LOCALE_META[locale], htmlLang: htmlLangFor(pathname) }
}
